import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getAllOrganizationsRequest = async (token) => {
  const url = apiURl + "organizations/getall";
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const addOrganizationRequest = async (organization, token) => {
  const url = apiURl + "organizations/create";

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(organization),
  };

  return fetchAndReturn(url, parameters);
};

const deleteOrganizationRequest = async (token, organization) => {
  const url = apiURl + "organizations/delete";
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(organization),
  };

  return fetchAndReturn(url, parameters);
};

const updateOrganizationRequest = async (organization, token) => {
  const url = apiURl + "organizations/edit";

  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(organization),
  };

  return fetchAndReturn(url, parameters);
};

const getAllCitiesRequest = async (token) => {
  const url = apiURl + "cities";
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};
const getAllRestauranstsRequest = async (token, organizationId) => {
  const url = apiURl + "restaurants?organizationId=" + organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const checkFireBirdDbVersionsRequest = async (token) => {
  const url = apiURl + "organizations/fireBirdDatabaseVersions";
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const checkFireBirdDbVersionsByUserRequest = async (token) => {
  const url = apiURl + "organizations/fireBirdDatabaseVersionsByUser";
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getMenuConfigurationRequest = async (organizationId, token) => {
  const url = apiURl + "MyMenu/MyMenuConfigurations/" + organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};
const checkOrganization = async (organization, token) => {
  const url = apiURl + "organizations/checkconnection";
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(organization),
  };

  return fetchAndReturn(url, parameters);
};

const getAllOrganizationsByUrlRequest = async (organizationIds, token) => {
  const url =
    apiURl +
    "organizations/getAllOrganizationsByIds?" +
    organizationIds
      .map((organizationId) => `organizationId=${organizationId}`)
      .join("&");
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export {
  getAllOrganizationsRequest,
  addOrganizationRequest,
  getAllCitiesRequest,
  deleteOrganizationRequest,
  updateOrganizationRequest,
  getAllRestauranstsRequest,
  checkFireBirdDbVersionsRequest,
  checkFireBirdDbVersionsByUserRequest,
  getMenuConfigurationRequest,
  checkOrganization,
  getAllOrganizationsByUrlRequest,
};
